// extracted by mini-css-extract-plugin
module.exports = {"nineGrid":"components_nineGrid__TeeB2"};